import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DatepickerInputCalendarComponent } from '../../../form-components/datepicker-input/datepicker-input-calendar/datepicker-input-calendar.component';
import { DatepickerInputComponent } from '../../../form-components/datepicker-input/datepicker-input.component';

@Component({
  selector: 'app-table-header-date-input',
  templateUrl: '../../../../ui/form-components/datepicker-input/datepicker-input.component.html',
  styleUrls: ['./table-header-date-input.component.scss', '../table-column-inputs.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderDateInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [AsyncPipe, MaskitoDirective, NgbPopover, DatepickerInputCalendarComponent]
})
export class TableHeaderDateInputComponent extends DatepickerInputComponent {
  @Input() placeholder: string = $localize`Search`;

  public onFocus(): void {
    super.onFocus();
    this.placeholder = 'DD/MM/YYYY';
  }

  public onBlur(): void {
    super.onBlur();
    this.placeholder = $localize`Select`;
  }
}
